/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import {
    array, bool, node, shape, string, func, object,
} from 'prop-types';
import React from 'react';
import { getOptionLabels, getSectionLabels } from './FoodConfigurator/LabelHelper';
import FoodConfiguratorOptions from './FoodConfiguratorOptions';

const FoodConfigurator = ({
    product, children, attributes, isSyConfigurator, handleSkuChange, selectedSku, defaultAttributes, skuAttributes, renderSingleSkuLayout, attributesWatchList, brandCode,
}) => {
    if (!isSyConfigurator || (
        attributes.net_weight.length === 0
        && attributes.quality_grade.length === 0
        && attributes.count.length === 0
        && attributes.wine_beer_type.length === 0)
    ) {
        return <>{children}</>;
    }

    const layout = {};

    if (defaultAttributes) {
        layout.skuAttributes = skuAttributes;

        defaultAttributes?.count?.item?.sort?.((a, b) => Number(a) - Number(b));

        defaultAttributes?.quality_grade?.item?.sort?.((a, b) => Number(a) - Number(b));

        defaultAttributes?.net_weight?.item?.sort?.((a, b) => Number(a?.split?.(' ')?.[0]) - Number(b?.split?.(' ')?.[0]));

        // TODO::Wine attribute to sort if needed. OR need to dynamic this logic!!!!!

        layout.default = defaultAttributes;
    }

    const flatLevel = Object.keys({ ...attributesWatchList });
    const levels = [];
    const availableSections = [];
    (flatLevel.filter((item) => defaultAttributes?.[item]?.item?.length > 0))?.forEach?.((item, index) => {
        levels.push({
            name: item,
            parent: index === 0 ? null : flatLevel[index - 1],
            totalItems: defaultAttributes?.[item]?.item?.length,
        });
        availableSections.push(item);
    });

    const labels = getSectionLabels(brandCode);
    const optionLabels = getOptionLabels(brandCode);

    return (
        <>
            {renderSingleSkuLayout}
            <FoodConfiguratorOptions
                levels={levels}
                attributesWatchList={attributesWatchList}
                layout={layout}
                handleSkuChange={handleSkuChange}
                product={product}
                selectedSku={selectedSku}
                optionLabels={optionLabels}
                labels={labels}
                availableSections={availableSections}
                renderSingleUI
            />
        </>
    );
};

FoodConfigurator.propTypes = {
    product: shape({
        name: string,
    }),
    attributes: shape({
        net_weight: array,
        quality_grade: array,
        count: array,
    }),
    isSyConfigurator: bool,
    children: node.isRequired,
    handleSkuChange: func,
    selectedSku: shape({
        id: string,
    }),
    defaultAttributes: object,
    skuAttributes: object,
    renderSingleSkuLayout: node.isRequired,
    attributesWatchList: array,
    brandCode: string,
};
FoodConfigurator.defaultProps = {
    product: null,
    selectedSku: {},
    attributes: {
        net_weight: [],
        quality_grade: [],
        count: [],
    },
    isSyConfigurator: false,
    handleSkuChange: () => {},
    defaultAttributes: {},
    skuAttributes: {},
    attributesWatchList: [],
    brandCode: '',
};

export default FoodConfigurator;
